export default {
    state: {
        loading: false, // 加载loading
        role: ""
    },
    getters: {

    },
    mutations() {
    },
    actions: {
        Jurisdiction({state}, index) {
            for (let i in state.list_aside) {
                if (i == index) {
                    state.list_aside[i].active = 1;
                } else {
                    state.list_aside[i].active = 0;
                }
            }
        }

    }
};



// WEBPACK FOOTER //
// ./src/store/system.js